export default {
  vgn: {
    name: 'Vegan',
    emoji: '🌱',
  },
  vgt: {
    name: 'Vegetariano',
    emoji: '🥬',
  },
  gf: {
    name: 'Sem glúten',
  },
  df: {
    name: 'Sem lactose',
  },
  hal: {
    name: 'Halal',
  },
  'h&s': {
    name: 'Picante',
    emoji: '🌶',
  },
};
